import request from '../../utils/request';

function rutStatus(rut) {
  return request({
    url: `/legal-person-enrollment/by-rut/${rut}/status`,
    method: 'GET',
  });
}

const InitPage = {
  rutStatus,
};

export default InitPage;
